module.exports = __webpack_public_path__ + "static/media/p2s.c74da4e8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p2s.webp
// module id = 263
// module chunks = 0